import { render, staticRenderFns } from "./ClientWalletChart.vue?vue&type=template&id=7226c8b9&"
import script from "./ClientWalletChart.vue?vue&type=script&lang=js&"
export * from "./ClientWalletChart.vue?vue&type=script&lang=js&"
import style0 from "./ClientWalletChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports